var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"review-modal-data-divider"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-divider',{staticClass:"grey lighten-3"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }